import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import dayjs from "dayjs";
import { data } from "../data";
import axios from "axios";
import { getPracticeId } from "../../config/practice";

const AortaUltrasoundview = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

    const fetchData = async () => {
      try {
   const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/${getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );
      
      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
      } catch (error) {
        console.error("Error fetching exam data:", error);
      }
    };
  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);

  return (
<div
  id={examData ? "report-ready" : undefined}
  className="p-6 bg-white min-h-screen w-full flex justify-center items-center"
>
  <div className="w-full max-w-3xl flex flex-col items-center border border-gray-300 rounded-md p-12 shadow-sm">
        {/* Header */}
        <div className="flex items-start w-full justify-center mb-6">
          <img src={BrianyCareLogo} alt="Logo" className="w-14 h-14 mr-3" />
          <div>
            <h1 className="text-xl font-bold text-blue-600 leading-none">C-HIM</h1>
            <p className="text-sm font-semibold mt-1">Center for Hypertension & Internal Medicine</p>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center font-bold text-base underline mb-4">AORTA ULTRASOUND</h2>

        {examData ? (
          <>
            <div className="flex justify-start text-sm text-left w-full mb-4">
                                <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                                  <span><strong>MR No#</strong></span>
                                  <span>:</span>
                                  <span>{examData.patientid}</span>
                              
                                  <span><strong>Name</strong></span>
                                  <span>:</span>
                                  <span>{examData.pat_name}</span>
                              
                                  <span><strong>Age</strong></span>
                                  <span>:</span>
                                  <span>{examData.age}</span>
                              
                                  <span><strong>Exam Date</strong></span>
                                  <span>:</span>
                                  <span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                              
                                  <span><strong>Date of Birth</strong></span>
                                  <span>:</span>
                                  <span>{dayjs(examData.pat_dob).format("MMM D, YYYY")}</span>
                              
                                  <span><strong>Provider</strong></span>
                                  <span>:</span>
                                  <span>{examData.providername}</span>
                              
                                  
                              
                                  <span><strong>Patients History</strong></span>
                                  <span>:</span>
                                  <span>{examData.history}</span>
                                </div>
                              </div>
            

            {/* Aorta Sagittal Measurements */}
            <h3 className="text-base font-semibold underline mb-2 w-full">Aorta Sagittal</h3>
            <div className="grid grid-cols-3 gap-4 text-sm w-full mb-4">
              <div><strong>Proximal:</strong> {examData.aortaSag.prox}</div>
              <div><strong>Mid:</strong> {examData.aortaSag.mid}</div>
              <div><strong>Distal:</strong> {examData.aortaSag.distal}</div>
            </div>

            {/* Aorta Transverse Measurements */}
            <h3 className="text-base font-semibold underline mb-2 w-full">Aorta Transverse</h3>
            <div className="grid grid-cols-3 gap-4 text-sm w-full mb-4">
              <div><strong>Proximal:</strong> {examData.aortaTrv.prox}</div>
              <div><strong>Mid:</strong> {examData.aortaTrv.mid}</div>
              <div><strong>Distal:</strong> {examData.aortaTrv.distal}</div>
            </div>

            {/* Iliacs Sagittal Measurements */}
            <h3 className="text-base font-semibold underline mb-2 w-full">Iliacs Sagittal</h3>
            <div className="grid grid-cols-3 gap-4 text-sm w-full mb-4">
              <div><strong>Proximal:</strong> {examData.iliacsSag.prox}</div>
              <div><strong>Mid:</strong> {examData.iliacsSag.mid}</div>
              <div><strong>Distal:</strong> {examData.iliacsSag.distal}</div>
            </div>

            {/* Iliacs Transverse Measurements */}
            <h3 className="text-base font-semibold underline mb-2 w-full">Iliacs Transverse</h3>
            <div className="grid grid-cols-3 gap-4 text-sm w-full mb-4">
              <div><strong>Proximal:</strong> {examData.iliacsTrv.prox}</div>
              <div><strong>Mid:</strong> {examData.iliacsTrv.mid}</div>
              <div><strong>Distal:</strong> {examData.iliacsTrv.distal}</div>
            </div>

            {/* Impression */}
            <div className="text-sm text-start w-full mb-6 ">
              <strong>Sonographer’s Impression:</strong> {examData.impression}
            </div>

                      {/* Signature */}
        <div className="flex justify-end w-full">
  <div className="relative flex items-stretch border p-2 min-w-[350px] max-w-full">
    
    {/* Signature - grows with content */}
    <div className="font-semibold pr-4 z-10 break-words whitespace-pre-wrap max-w-[50%]">
      {examData.signature}
    </div>

    {/* Divider */}
    <div className="absolute top-0 bottom-0 left-1/2 w-px bg-gray-300" />

    {/* Right section - always left aligned */}
    <div className="text-sm text-left z-10 pl-4 w-1/2">
      <div>Digitally Signed by</div>
    <div>{examData?.createdby||''}</div>
        <div>{dayjs(examData.dateofservice).format("MM-DD-YYYY")}</div>
    </div>
  </div>
</div>
          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default AortaUltrasoundview;
